(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ils-polaroids"] && !Shopify.designMode) return;
  try {
    
  /* Write each post's caption in the polaroid's bottom strip, the way you'd label a real polaroid.
     Instafeed puts the caption in the photo's alt text ("Instagram post with the caption: ...").
     Reels don't carry a caption there, so they get a short fallback. Clicking still opens the post. */
  (function () {
    function shorten(text, max) {
      var t = (text || '').replace(/^Instagram post with the caption:\s*/i, '').split('\n')[0];
      t = t.replace(/#[\wÀ-ɏ]+/g, '').replace(/\.\.\.$/, '').replace(/\s+/g, ' ').trim();
      if (t.length > max) t = t.slice(0, max).replace(/\s+\S*$/, '') + '…';
      return t;
    }
    function label(feed) {
      var items = feed.querySelectorAll('.instafeed-new-layout-item');
      if (!items.length) return false;
      for (var i = 0; i < items.length && i < 5; i++) {
        var item = items[i];
        if (item.querySelector('.ils-if-cap')) continue;
        var img = item.querySelector(':scope > img');
        var cap = shorten(img ? img.getAttribute('alt') : '', 42);
        if (!cap) cap = item.querySelector(':scope > video') ? 'watch the reel ♡' : 'life at the shop';
        var span = document.createElement('span');
        span.className = 'ils-if-cap';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = cap;
        item.appendChild(span);
      }
      return true;
    }
    function init() {
      document.querySelectorAll('.ils-instafeed #insta-feed').forEach(function (feed) {
        if (label(feed)) return;
        var obs = new MutationObserver(function () { if (label(feed)) obs.disconnect(); });
        obs.observe(feed, { childList: true, subtree: true });
        setTimeout(function () { obs.disconnect(); }, 20000);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
